<template>
  <div id="archive-filter-letter" :data-color="color">
    <ul>
      <li v-for="char in allLetters" :key="char.id">
        <router-link v-if="hasRouterParams" :to="{ name: $route.name, params: { id: char } }">
          {{ char }}
        </router-link>
        <router-link v-else :to="{ path: `${$route.fullPath}/${char}` }">
          {{ char }}
        </router-link>
      </li>
      <li class="nav-item">
        <router-link v-if="hasRouterParams" :to="{ name: $route.name, params: { id: 'all' } }">
          all
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ArchiveFilterLetter',

  props: {
    color: {
      type: String,
      required: false,
      default: 'black',
      description: 'black | white'
    }
  },

  computed: {
    allLetters() {
      return [...Array(26)].map((_, y) => String.fromCharCode(y + 65).toLowerCase());
    },
    hasRouterParams() {
      return Object.keys(this.$route.params).length > 0;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
#archive-filter-letter {
  &[data-color="white"] {
    a {
      color: $c_sub_nav_text;
      &.router-link-exact-active.router-link-active {
        color: $c_white;
      }
    }
  }
  &[data-color="black"] {
    a {
      color: $c_text_shade;
      &.router-link-exact-active.router-link-active {
        color: $c_black;
      }
    }
  }
  margin: 0 auto;
  @media (max-width: 768px) {
    display: none;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    line-height: 1;
    li {
      &:last-child {
        margin-right: 0;
      }
      a {
        text-transform: uppercase;
        text-decoration: none !important;
        border-bottom: none !important;
        @include font-10-md;
        padding: 0 4px;
        &:hover {
          color: $c_base;
        }
        &.router-link-exact-active.router-link-active {
          &:hover {
            color: $c_base !important;
          }
        }
      }
    }
  }
}
</style>
